import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Voice-driven fixture control shared by every fixture page. Reacts to EVERY navigation (loc.key), not just the
// first mount, so a hands-free "open Benfica–Porto" lands even when the page is already open:
//   pendingFixture → onPending (clear the old fixture so nothing stale shows)
//   team_id / opponent_id / league → apply, then onFixture (pages reset their autorun so the plan re-runs)
//   window 'octon:rerun' → onRerun (voice "reload / run it again")
export const useVoiceFixture = ({ setLeague, setTeamId, setOppId, onPending, onFixture, onRerun }) => {
  const loc = useLocation();
  useEffect(() => {
    const p = loc.state || {};
    if (p.pendingFixture) { onPending && onPending(); return; }
    if (p.team_id || p.opponent_id) {
      if (p.league && setLeague) setLeague(p.league);
      if (p.team_id && setTeamId) setTeamId(p.team_id);
      if (p.opponent_id && setOppId) setOppId(p.opponent_id);
      onFixture && onFixture(p);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc.key]);
  useEffect(() => {
    if (!onRerun) return;
    const h = () => onRerun();
    window.addEventListener("octon:rerun", h);
    return () => window.removeEventListener("octon:rerun", h);
  }, [onRerun]);
};
